module.exports = __webpack_public_path__ + "img/renewal-card.99994e27.svg";